import styled from "styled-components";
import BoxBase from "../../../layout/boxes/BoxBase";
import { StyledBadgeBaseProps } from "./BadgeBase.types";

const StyledBadgeBase = styled(
	({
		color,
		icon,
		iconColor,
		iconPosition,
		size,
		...props
	}: StyledBadgeBaseProps) => <BoxBase {...props} />
)<StyledBadgeBaseProps>`
	${(props) => {
		const theme = props.theme;

		return {
			borderRadius: (() => {
				switch (props.size) {
					case "lg":
						return theme.radii.lg;
					case "md":
						return theme.radii.md;
					default:
						return theme.radii.sm;
				}
			})(),
			".Typography": {
				color: theme.palette.hexFor(props.color),
				lineHeight: "unset",
			},
			".Icon": {
				display: "flex",
			},
			".Icon svg": {
				fill: theme.palette.hexFor(props.iconColor),
			},
		};
	}}
`;

export default StyledBadgeBase;
